import React from 'react'
import styled from 'styled-components'
import Image from 'common/image'
import { useSelector } from 'react-redux'
import StepArrow from 'assets/step_arrow.svg'
import { useTranslation } from 'react-i18next'
import { adobeInteractionEvent } from 'utils/adobewa'

const BoxContainer = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    width: 359px;
    padding: 32px 0px;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const TitleContainer = styled.div`
    padding-right: 20px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 81px;
`

const Title1Container = styled.div`
    padding-right: 20px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 59px;
`

const TitleText = styled.div`
    color: #121b21;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
`

const TitleUnderLine = styled.div`
    margin-top: 16px;
    width: 59px;
    height: 5px;
    background: #d9c277;
`

const FirstLineText = styled.div`
    padding-right: 20px;
    padding-left: 20px;
    margin-top: 32px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 175% */
`

const SecondLineText = styled.div`
    padding-right: 20px;
    padding-left: 20px;
    margin-top: 16px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 125% */
`

const PriorityColumnContainer = styled.div`
    margin-top: 16px;
    width: 319px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
`

const PrioirtyCardDisplayColumn = styled.div`
    width: 142px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`

const PriorityDisplayCardItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const CardTierText = styled.div`
    width: 142px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */

    margin-top: 8px;
    margin-bottom: 32px;
`

const ProgressBarContainer = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
`

const ProgressCardItemContainer = styled.div`
    margin-top: 16px;
    margin-left: 12px;
    margin-right: 18px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`

interface Props {
    $color: string
}

const ProgressNumber = styled.div`
    color: var(--Secondary-Color-Dark-Grey, #606060);
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 35px; /* 175% */

    margin-bottom: 118px;
`

const ProgressBar = styled.div<Props>`
    width: 6px;
    height: 101px;
    background: ${(p) => p.$color};
`

const UnlockText = styled.div`
    margin-top: 35px;
    color: var(--Secondary-Color-Dark-Brown, #4e3821);
    text-align: center;
    align-self: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

const TierBenefitScrollContainer = styled.div`
    width: 359px;
    overflow-x: scroll;
`

const TierBenefitContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 1708px;
    height: 100%;
    display: flex;
    padding: 24px 56px;
    border-top: 1px solid #003c84;
    background: #fafafa;
`

const TierBenefitItemRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
`

const TierBenefitItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 246px;
    gap: 12px;
`

const TierBenefitItemText = styled.div`
    min-height: 69px;
    color: var(--Brand-Color-Black, #121b21);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px; /* 143.75% */
`

interface TierBenefitButtonProps {
    $color: string
}

const TierBenefitItemButton = styled.div<TierBenefitButtonProps>`
    width: 180px;
    padding: 6px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background: ${(p) => p.$color};
    color: white;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 23px;
`

const ExploreButton = styled.div`
    margin-top: 40px;
    display: flex;
    width: 280px;
    height: 55px;
    padding: 8px 48px;
    justify-content: center;
    align-items: center;
    border-radius: 200px;
    background: var(--Brand-Color-Yellow, #c5924d);
    align-self: center;
    cursor: pointer;
`

const ExploreButtonText = styled.div`
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

// const PrivilegeTutorial = styled.div`
//     margin-top: 40px;
//     width: 100%;
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: flex-start;
// `

// const VideoAreaContainer = styled.div`
//     width: 100%;
//     display: flex;
//     flex-direction: center;
//     justify-content: center;
// `

// const VideoArea = styled.div`
//     width: 316px;
//     height: 193px;
//     margin-top: 40px;
// `

const TutorialTextContainer = styled.div`
    margin-top: 40px;
`

const TutorialScrollContainer = styled.div`
    width: 319px;
    overflow-x: scroll;
`

const TutorialContainer = styled.div`
    width: 924px;
    display: flex;
    flex-direction: row;
    padding: 16px 0px;
`

const StepContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-right: 40px;
    margin-left: 40px;
`

const StepText = styled.div`
    padding-top: 40px;
    color: #4e3821;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px; /* 125% */
`

const SubTitleText = styled.div`
    padding-top: 12px;
    color: #835d35;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

const ContentText = styled.div`
    padding-top: 16px;
    color: #835d35;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const StepArrowContainer = styled.div`
    display: flex;
    height: 558px;
`

export default function StatusPointAndTier() {
    const { i18n, t } = useTranslation('', {
        keyPrefix: 'priorityprogramme.statuspointandtier',
    })
    const lang = i18n.language
    const configs = useSelector((state: any) => state.config.configs)

    const exploreAllPrivilegeButtonClick = (url: string) => {
        window.open(url, '_blank')?.focus()
        adobeInteractionEvent({
            lang: lang,
            eventID: `prioritysite_click_Program_Privilege_Explore`,
        })
    }

    // const videoOnplay = (url: string) => {
    //     adobeInteractionEvent({
    //         lang: lang,
    //         eventID: `prioritysite_clickPlayVideo_Program_Tutorial_Video`,
    //         videoFileName: url,
    //     })
    // }

    return (
        <BoxContainer>
            <TitleContainer>
                <TitleText>{t(`STATUSPOINTS`)}</TitleText>
                <TitleUnderLine />
            </TitleContainer>
            <FirstLineText>{t(`Upgrading`)}</FirstLineText>
            <SecondLineText>
                {t(`PriorityProgramme`)} <br />
                {t(`Eachtieroffers`)}
            </SecondLineText>
            <UnlockText>{t(`Unlockhigher`)}</UnlockText>
            <PriorityColumnContainer>
                <ProgressBarContainer>
                    <ProgressNumber>0</ProgressNumber>
                    <ProgressNumber>6,000</ProgressNumber>
                    <ProgressNumber>10,000</ProgressNumber>
                    <ProgressNumber>30,000</ProgressNumber>
                    <ProgressNumber>120,000</ProgressNumber>
                </ProgressBarContainer>
                <ProgressCardItemContainer>
                    <Image
                        src={t(`yellowCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Yellow Card"
                    />
                    <ProgressBar $color={`var(--Brand-Color-Red, #9B2541)`} />
                    <Image
                        src={t(`redCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Red Card"
                    />
                    <ProgressBar
                        $color={`var(--Silver-2, linear-gradient(90deg, #888989 0%, #AAAAAB 59%, #CBCBCB 100%))`}
                    />
                    <Image
                        src={t(`silverCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Silver Card"
                    />
                    <ProgressBar
                        $color={`var(--Gold-Bar, linear-gradient(279deg, #AF944F 4.78%, #CAB273 96.85%))`}
                    />
                    <Image
                        src={t(`goldCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Gold Card"
                    />
                    <ProgressBar $color={`var(--Brand-Color-Black, #121B21)`} />
                    <Image
                        src={t(`blackCardIconImage`)}
                        width={52}
                        height={52}
                        alt="Black Card"
                    />
                </ProgressCardItemContainer>
                <PrioirtyCardDisplayColumn>
                    <PriorityDisplayCardItem>
                        <Image
                            src={t(`yellowCardImage`)}
                            width={142}
                            height={91}
                            alt="Yellow Card"
                            style={{
                                borderRadius: '4px',
                                background: 'lightgray 50% / cover no-repeat',
                            }}
                        />
                        <CardTierText>{t(`PriorityYellow`)}</CardTierText>
                    </PriorityDisplayCardItem>
                    <PriorityDisplayCardItem>
                        <Image
                            src={t(`redCardImage`)}
                            width={142}
                            height={91}
                            alt="Red Card"
                            style={{
                                borderRadius: '4px',
                            }}
                        />
                        <CardTierText>{t(`PriorityRed`)}</CardTierText>
                    </PriorityDisplayCardItem>
                    <PriorityDisplayCardItem>
                        <Image
                            src={t(`silverCardImage`)}
                            width={142}
                            height={91}
                            alt="Silver Card"
                            style={{
                                borderRadius: '4px',
                            }}
                        />
                        <CardTierText>{t(`PrioritySilver`)}</CardTierText>
                    </PriorityDisplayCardItem>
                    <PriorityDisplayCardItem>
                        <Image
                            src={t(`goldCardImage`)}
                            width={142}
                            height={91}
                            alt="Gold Card"
                            style={{
                                borderRadius: '4px',
                            }}
                        />
                        <CardTierText>{t(`PriorityGold`)}</CardTierText>
                    </PriorityDisplayCardItem>
                    <PriorityDisplayCardItem>
                        <Image
                            src={t(`blackCardImage`)}
                            width={142}
                            height={91}
                            alt="Black Card"
                            style={{
                                borderRadius: '4px',
                            }}
                        />
                        <CardTierText>{t(`PriorityBlack`)}</CardTierText>
                    </PriorityDisplayCardItem>
                </PrioirtyCardDisplayColumn>
            </PriorityColumnContainer>
            <TierBenefitScrollContainer>
                <TierBenefitContainer>
                    <TierBenefitItemRow>
                        <TierBenefitItem>
                            <Image
                                src={t(`yellowCardPrivilegeImage`)}
                                width={30}
                                height={30}
                                alt="Calendar Image"
                            />
                            <TierBenefitItemText>
                                {t(`yellowPrivilege`)}
                            </TierBenefitItemText>
                            <TierBenefitItemButton $color={' #D7A717'}>
                                {t(`yellowExclusiveText`)}
                            </TierBenefitItemButton>
                        </TierBenefitItem>
                        <TierBenefitItem>
                            <Image
                                src={t(`redCardPrivilegeImage`)}
                                width={30}
                                height={30}
                                alt="Calendar Image"
                            />
                            <TierBenefitItemText>
                                {t(`redPrivilege`)}
                            </TierBenefitItemText>
                            <TierBenefitItemButton $color={' #9B2541'}>
                                {t(`redExclusiveText`)}
                            </TierBenefitItemButton>
                        </TierBenefitItem>
                        <TierBenefitItem>
                            <Image
                                src={t(`silverCardPrivilegeImage`)}
                                width={30}
                                height={30}
                                alt="Calendar Image"
                            />
                            <TierBenefitItemText>
                                {t(`silverPrivilege`)}
                            </TierBenefitItemText>
                            <TierBenefitItemButton $color={' #AAAAAB'}>
                                {t(`silverExclusiveText`)}
                            </TierBenefitItemButton>
                        </TierBenefitItem>
                        <TierBenefitItem>
                            <Image
                                src={t(`goldCardPrivilegeImage`)}
                                width={30}
                                height={30}
                                alt="Calendar Image"
                            />
                            <TierBenefitItemText>
                                {t(`goldPrivilege`)}
                            </TierBenefitItemText>
                            <TierBenefitItemButton $color={' #CAB273'}>
                                {t(`goldExclusiveText`)}
                            </TierBenefitItemButton>
                        </TierBenefitItem>
                        <TierBenefitItem>
                            <Image
                                src={t(`blackCardPrivilegeImage`)}
                                width={30}
                                height={30}
                                alt="Calendar Image"
                            />
                            <TierBenefitItemText>
                                {t(`blackPrivilege`)}
                            </TierBenefitItemText>
                            <TierBenefitItemButton $color={' #121B21'}>
                                {t(`blackExclusiveText`)}
                            </TierBenefitItemButton>
                        </TierBenefitItem>
                        <TierBenefitItem>
                            <Image
                                src={t(`blackCard2PrivilegeImage`)}
                                width={30}
                                height={30}
                                alt="Calendar Image"
                            />
                            <TierBenefitItemText>
                                {t(`black2Privilege`)}
                            </TierBenefitItemText>
                            <TierBenefitItemButton $color={' #121B21'}>
                                {t(`black2ExclusiveText`)}
                            </TierBenefitItemButton>
                        </TierBenefitItem>
                    </TierBenefitItemRow>
                </TierBenefitContainer>
            </TierBenefitScrollContainer>
            <ExploreButton>
                <ExploreButtonText
                    onClick={() => {
                        exploreAllPrivilegeButtonClick(
                            t(`ExploreAllPrivilegeUrl`)
                        )
                    }}
                >
                    {t(`ExploreAllPrivilege`)}
                </ExploreButtonText>
            </ExploreButton>
            <TutorialTextContainer>
                <Title1Container>
                    <TitleText>{t(`TUTORIALOFTIER`)}</TitleText>
                    <TitleUnderLine />
                </Title1Container>
            </TutorialTextContainer>
            <TutorialScrollContainer>
                <TutorialContainer>
                    {configs.priorityprogramme?.tutorialOfTierPrivileges?.map(
                        (item: any, index: string) => {
                            return (
                                <React.Fragment
                                    key={`step-tutorial-privilege-` + index}
                                >
                                    <StepContainer>
                                        <Image
                                            src={
                                                lang === 'zh'
                                                    ? item.path_zh
                                                    : item.path_en
                                            }
                                            width={275}
                                            height={468}
                                            alt="Step One Screen Picture"
                                        />
                                        <StepText>
                                            {lang === 'zh'
                                                ? item.step_zh
                                                : item.step_en}
                                        </StepText>
                                        <SubTitleText>
                                            {lang === 'zh'
                                                ? item.text_zh
                                                : item.text_en}
                                        </SubTitleText>
                                        <ContentText>
                                            {lang === 'zh'
                                                ? item.content_zh
                                                : item.content_en}
                                        </ContentText>
                                    </StepContainer>
                                    {index + 1 !==
                                    configs.priorityprogramme
                                        ?.tutorialOfTierPrivileges?.length ? (
                                        <StepArrowContainer>
                                            <Image
                                                src={StepArrow}
                                                width={16}
                                                height={178}
                                                alt="Step Arrow Icon"
                                                style={{
                                                    alignSelf: 'flex-end',
                                                    flexShrink: '0',
                                                }}
                                            />
                                        </StepArrowContainer>
                                    ) : null}
                                </React.Fragment>
                            )
                        }
                    )}
                </TutorialContainer>
            </TutorialScrollContainer>
            {/* <PrivilegeTutorial>
                <Title1Container>
                    <TitleText>{t(`TUTORIALOFPRIVILEGE`)}</TitleText>
                    <TitleUnderLine />
                </Title1Container>
                <VideoAreaContainer>
                    <VideoArea>
                        <video
                            title="tutorial of earn wins"
                            controls
                            style={{
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%',
                                borderRadius: '25px',
                            }}
                            src={t(`video`)}
                            onPlay={() => {
                                videoOnplay(t(`video`))
                            }}
                        />
                    </VideoArea>
                </VideoAreaContainer>
            </PrivilegeTutorial> */}
        </BoxContainer>
    )
}
